import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMABAA080AdminRegisterBanner, postMABAA080RecruitFixJumpUp } from '../../../../services/Api';
import { formatDate, formatDatePayload, handleFocus } from '../../../../utils';
const PopupMABAA080_5 = ({ onClose, additionalData }) => {
    const { memberID, recruitSeq, title, recruitEnd, recruitFrom } = additionalData;
    const [popupDataComment, setPopupDataComment] = useState([]);
    const [popupDataCompanyName, setPopupDataCompanyName] = useState('');
    const [payload, setPayload] = useState({
        memberID,
        recruitSeq,
        recruitFrom,
        recruitEnd,
        comment: '',
        payStatus: '',
        actInputName: '',
    });

    useEffect(() => {
        getMABAA080AdminRegisterBanner({
            params: {
                memberID,
                recruitSeq,
            },
        })
            .then(({ data }) => {
                setPopupDataComment(data.comments);
                setPopupDataCompanyName(data.companyName);
            })
            .catch((error) => console.log(error));
    }, [memberID, recruitSeq]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (!payload.goodCode) {
            alert('상품명을 입력해 주세요.');
            handleFocus('goodCode');
            return;
        }

        if (!payload.optStart) {
            alert('옵션 시작일을 선택해 주세요.');
            handleFocus('optStart');
            return;
        }

        const formattedOptStart = formatDatePayload(payload?.optStart);
        const formattedRecruitFrom = formatDatePayload(payload.recruitFrom);
        const formattedRecruitEnd = formatDatePayload(payload.recruitEnd);

        if (formattedOptStart < formattedRecruitFrom) {
            alert('옵션 시작일이 채용 시작일 이전입니다.옵션 시작일을 확인하세요.');
            handleFocus('optStart');
            return;
        }

        if (!payload.optEnd) {
            alert('옵션 종료일을 선택해 주세요.');
            handleFocus('optEnd');
            return;
        }

        const formattedOptEnd = formatDatePayload(payload.optEnd);

        if (formattedRecruitFrom > formattedRecruitEnd) {
            alert('채용 종료일이 채용 시작일 이전입니다.');
            handleFocus('recruitFrom');
            return;
        }

        if (formattedOptEnd > formattedRecruitEnd) {
            alert('옵션 종료일이 채용 종료일 이후입니다.옵션 종료일을 확인하세요.');
            handleFocus('optEnd');
            return;
        }

        if (!payload.payStatus) {
            alert('결제여부를 선택해 주세요.');
            handleFocus('payStatus');
            return;
        }

        let formattedApplyDate = '';
        if (!payload.applDate) {
            formattedApplyDate = '';
        } else {
            formattedApplyDate = formatDatePayload(payload.applDate);
        }

        const updatedPayload = {
            ...payload,
            optStart: formattedOptStart,
            optEnd: formattedOptEnd,
            recruitFrom: formattedRecruitFrom,
            recruitEnd: formattedRecruitEnd,
            applDate: formattedApplyDate,
        };

        postMABAA080RecruitFixJumpUp(updatedPayload)
            .then(() => {
                alert('옵션상품 등록이 완료되었습니다.');
                onClose();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="dental-information" className="dental-information">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={onClose} />
                        <div className="popup-header">[옵션추가]</div>
                        <div className="popup-title">진행중인 채용광고에 옵션추가등록 - 신규강조추가등록</div>
                        <div className="table-dental-information">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>아이디</td>
                                        <td>{memberID}</td>
                                        <td>치과명</td>
                                        <td>{popupDataCompanyName}</td>
                                    </tr>
                                    <tr>
                                        <td>제목</td>
                                        <td colSpan={3}>{title}</td>
                                    </tr>
                                    <tr>
                                        <td>채용시작일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitFrom', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitFrom || ''}
                                                maxDate={payload.recruitEnd || null}
                                                id="recruitFrom"
                                            />
                                        </td>
                                        <td>채용종료일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitEnd', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitEnd || ''}
                                                minDate={payload.recruitFrom || null}
                                                id="recruitEnd"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>상품명</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="goodCode" onChange={handleInputChange}>
                                                    <option value="">선택</option>
                                                    <option value="5001">고정옵션(체험)</option>
                                                    <option value="5100">고정옵션(추가)</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>입금자명</td>
                                        <td>
                                            <input type="text" name="actInputName" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>옵션시작일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'optStart', value: date } })
                                                }
                                                id="optStart"
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.optStart || ''}
                                                maxDate={payload.optEnd || null}
                                            />
                                        </td>
                                        <td>옵션종료일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'optEnd', value: date } })
                                                }
                                                id="optEnd"
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.optEnd || ''}
                                                minDate={payload.optStart || null}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>결제여부</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="payStatus" id="payStatus" onChange={handleInputChange}>
                                                    <option value="">선택</option>
                                                    <option value="Y">결제</option>
                                                    <option value="N">미결제</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>결제일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'applDate', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.applDate || ''}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comment</td>
                                        <td colSpan={3}>
                                            <textarea name="comment" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="note-table">
                            ※ Comment 등록형식 : [상품명]/ [Comment]. ex) 프리미엄배너 / 전화가 안와요 불만)
                            <br />
                            ※ 새로운 채용광고로 등록됩니다. 기간연장은 재사용 버튼을 사용하세요.
                            <br />※ 상품명 중 덴탈잡이 포함된 상품은 유료상품입니다.
                        </div>
                        <div className="group-btn">
                            <button className="popup-button" onClick={handleSave}>
                                등록 / 수정
                            </button>
                        </div>
                        <div className="table-comment-results">
                            <div className="table-comment-results-title">
                                등록된 Comment (
                                {popupDataComment && popupDataComment.length > 0 ? popupDataComment.length : 0})
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th>Seq</th>
                                        <th>등록일</th>
                                        <th>관리자명</th>
                                        <th>등록사이트</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {popupDataComment && popupDataComment.length > 0 ? (
                                        popupDataComment.map((item) => (
                                            <tr key={item.seq}>
                                                <td>{item.seq}</td>
                                                <td>{formatDate(item.addDate)}</td>
                                                <td>{item.adminName}</td>
                                                <td>{item.sitePos}</td>
                                                <td>{item.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                데이타가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMABAA080_5;
